import { NETSAVE_LOGO_ICON_URL } from "../../config/urls";

export default function NetSaveLogo({size=32,textMode=false,theme="dark"}){
  const imgH = size;
  const imgW = size * (1366/316); // original aspect ratio ~4.32:1
  const cappedW = Math.min(imgW, 200);
  if(!textMode) return <img src={NETSAVE_LOGO_ICON_URL} alt="NetSave" style={{height:imgH,width:"auto",objectFit:"contain"}} onError={e=>{e.target.style.display="none";}}/>;
  return <img src={NETSAVE_LOGO_ICON_URL} alt="NetSave Tax & Accounting" style={{height:imgH,width:"auto",maxWidth:cappedW,objectFit:"contain"}} onError={e=>{e.target.style.display="none";}}/>;
}
